module.exports = __webpack_public_path__ + "img/payback_bold-webfont.3738bf9a.svg";